import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  IVersionsPayload,
  IVersionsResponse,
  IVersionResponse
} from '@/apps/traforama/interfaces/versions'

export const fetchItems = async (
  payload: IVersionsPayload
): Promise<IVersionsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.get<IVersionsResponse>('/versions', {
    params
  })
  return response.data
}

export const fetchItem = async (id: string): Promise<IVersionResponse> => {
  const response = await apiClient.get<IVersionResponse>(`/versions/${id}`)
  return response.data
}
